import { BaseModel } from '../models/base.model';
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Page } from '../../models/page.model';

export abstract class BaseService<T extends BaseModel> {
  protected http: HttpClient;

  constructor(
    protected apiPath: string,
    protected injector: Injector) {
    this.http = injector.get(HttpClient);
  }

  getAll(): Observable<Page<T>> {
    return this.http.get<Page<T>>(this.apiPath);
  }

  getById(id: number): Observable<T> {
    const url = `${this.apiPath}/${id}`;

    return this.http.get<T>(url);
  }

  create(resource: T): Observable<T> {
    return this.http.post<T>(this.apiPath, resource);
  }

  update(resource: T): Observable<T> {
    return this.http.put<T>(`${this.apiPath}/${resource.id}`, resource);
  }

  delete(id: number): Observable<any> {

    const url = `${this.apiPath}/${id}`;

    return this.http.delete(url);
  }

  // PROTECTED METHODS
  protected handleError(error: any): Observable<any> {
    console.log('ERRO NA REQUISIÇÃO => ', error);
    return throwError(error);
  }
}
